import * as Constants from '@/lib/constants'
import i18n from '@/lib/i18n'
import * as SystemOfUnits from '@/lib/system-of-units'
import { MeterPerSecond, MilePerHour } from '@/lib/system-of-units-constants'
import axios from 'axios'

const BASE_ENDPOINT = 'https://api.openweathermap.org/data/2.5'

export default class OpenWeatherMapClient {
  static getForecast(lat, lon) {
    const endpoint = this._buildEndpoint('forecast', 'json', lat, lon)
    return this._httpClient().get(endpoint)
  }

  static getCurrent(lat, lon) {
    const endpoint = this._buildEndpoint('weather', 'json', lat, lon)
    return this._httpClient().get(endpoint)
  }

  static getWeatherIconUrl(icon) {
    return 'https://openweathermap.org/img/w/' + icon + '.png'
  }

  static getWindSpeedUnit() {
    // Metric: meter/sec, Imperial: miles/hour.
    if (SystemOfUnits.isImperial()) {
      return MilePerHour
    }
    return MeterPerSecond
  }

  static getTemperatureUnit() {
    // Metric: Celsius, Imperial: Fahrenheit.
    if (SystemOfUnits.isImperial()) {
      return '&#8457;' // Fahrenheit
    }
    return '&#8451;' // Celsius
  }

  static _buildEndpoint(type, mode, lat, lon) {
    let endpoint = BASE_ENDPOINT + '/' + type + '?'
    endpoint += 'mode=' + mode
    endpoint += '&APPID=' + Constants.OPEN_WEATHER_MAP_KEY
    endpoint += '&units=' + SystemOfUnits.getCurrentSystemOfUnits()
    endpoint += '&lang=' + i18n.getUserLang()
    endpoint += '&lat=' + lat + '&lon=' + lon
    return endpoint
  }

  static _httpClient() {
    let httpClient = axios.create()
    return httpClient
  }
}
